import { Link } from 'react-router-dom';
import { Compass } from 'lucide-react';
import { Button } from '@/components/ui';

export function NotFoundPage() {
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center text-center">
      <span className="flex size-16 items-center justify-center rounded-full bg-surface-hover text-brand-primary">
        <Compass className="size-8" />
      </span>
      <p className="mt-6 text-5xl font-extrabold tracking-tight text-content-primary">404</p>
      <p className="mt-2 text-sm text-content-secondary">Cette page n'existe pas ou a été déplacée.</p>
      <Button asChild className="mt-6">
        <Link to="/">Retour au tableau de bord</Link>
      </Button>
    </div>
  );
}
